/** Catalog reply debit for ChatForge. Must match forge-backend CHATFORGE_DEBIT_USD. */
export const CHATFORGE_DEBIT_USD = 0.008;
export const CATALOG_WRITE_DEBIT_USD = 0.02;

export function catalogChatDebitUsd(client: string): number {
  return (client || "").toLowerCase() === "chatforge"
    ? CHATFORGE_DEBIT_USD
    : CATALOG_WRITE_DEBIT_USD;
}

export function catalogReplyHint(source: "catalog" | "endpoint"): string {
  if (source === "endpoint") return "billed per request (endpoint hourly slice)";
  return `~${(CHATFORGE_DEBIT_USD * 100).toFixed(1)}¢`;
}
